import React from 'react'
import './style.css'

const Loading = () => {
  return (
    <div className='loading-container'>
        <div className='loading'></div>
    </div>
  )
}

export default Loading